import I18n from 'I18n';
import { useMemo } from 'react';
export const useUsersAndTeamsPlaceholder = (teamOptions, userOptions) => useMemo(() => {
  if (teamOptions.length === 0 && userOptions.length === 0) {
    return I18n.text('routing-ui.users-and-teams.select.placeholder-unavailable');
  }
  if (teamOptions.length === 0) {
    return I18n.text('routing-ui.users-and-teams.select.placeholder-user-only');
  }
  if (userOptions.length === 0) {
    return I18n.text('routing-ui.users-and-teams.select.placeholder-team-only');
  }
  return I18n.text('routing-ui.users-and-teams.select.placeholder');
}, [teamOptions, userOptions]);